import React from "react";
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';

export default function InputMaskEIN(props) {
  const { inputRef, onChange, ...inputMaskProps } = props;

  return (
    <InputMask
      {...inputMaskProps}
      inputRef={inputRef}
      mask="99-9999999"
      onChange={onChange}
    />
  );
}

InputMaskEIN.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Formatters/InputMaskEIN.js